const cdnDomain = process.env.NEXT_PUBLIC_CDN_DOMAIN || 'https://cdn-staging.qlub.io';
const env = process.env.NEXT_PUBLIC_ENV || 'staging';
const baseUrl = cdnDomain ? `https://${cdnDomain.replace(/^https?:\/\//, '')}` : '';

export const apiEndpoints = {
    getForCountry: `${baseUrl}/tutorials/${env}/:namespace/:cc/content.json`,
    getForRestaurant: `${baseUrl}/tutorials/${env}/:namespace/:cc/:slug/content.json`,
};

export default apiEndpoints;
